module.exports = __webpack_public_path__ + "img/1_m.60022597.jpg";